export default [
  {
    path: '/settings/financial',
    redirect: '/settings/financial/banksSettings',
    name: 'financialSettings',
    component: () => import('@/views/settings/financial/FinancialSettings.vue'),
    meta: {
      action: [
        'ROLE_BANCO_CONSULTAR',
        'ROLE_TIPO_CONTA_CONSULTAR',
        'ROLE_PLANO_DE_CONTA_CONSULTAR',
        'ROLE_TIPO_PAGAMENTO_RECEBIMENTO_CONSULTAR',
        'ROLE_FORMA_PAGAMENTO_RECEBIMENTO_CONSULTAR',
        'ROLE_FAIXA_CONTRIBUICAO_CONSULTAR',
        'ROLE_PARAMETROS_CONSULTAR',
        'ROLE_TAXA_CONSULTAR',
        'ROLE_ENCARGOS_CONSULTAR',
        'ROLE_TIPO_FAIXA_CONSULTAR',
        'ROLE_PERIODO_VIGENCIA_CONSULTAR',
        'ROLE_VALOR_FAIXA_CONSULTAR',
        'ROLE_MOEDA_CONSULTAR',
      ],
      resource: 'ACL',
      pageTitle: 'Financeiro',
      breadcrumb: [
        {
          text: 'Cadastros Módulo Financeiro',
        },
      ],
    },
    children: [
      {
        path: 'banksSettings',
        name: 'banksSettings',
        component: () => import('@/views/settings/financial/BankSetting.vue'),
        meta: {
          action: ['ROLE_BANCO_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Bancos',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Bancos',
            },
          ],
        },
      },
      {
        path: 'accountTypeSettings',
        name: 'accountTypeSettings',
        component: () => import('@/views/settings/financial/AccountTypeSetting.vue'),
        meta: {
          action: ['ROLE_TIPO_CONTA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Tipos de Contas',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Tipos de Contas',
            },
          ],
        },
      },
      {
        path: 'accountPlanSettings',
        name: 'accountPlanSettings',
        component: () => import('@/views/settings/financial/AccountPlanSetting.vue'),
        meta: {
          action: ['ROLE_PLANO_DE_CONTA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Plano de Contas',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Plano de Contas',
            },
          ],
        },
      },
      {
        path: 'typeOfPaymentReceiptSettings',
        name: 'typeOfPaymentReceiptSettings',
        component: () => import('@/views/settings/financial/TypeOfPaymentReceiptSetting.vue'),
        meta: {
          action: ['ROLE_TIPO_PAGAMENTO_RECEBIMENTO_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Tipos de Pagamentos / Recebimentos',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Tipos de Pagamentos / Recebimentos',
            },
          ],
        },
      },
      {
        path: 'paymentMethodsSettings',
        name: 'paymentMethodsSettings',
        component: () => import('@/views/settings/financial/PaymentMethodsSetting.vue'),
        meta: {
          action: ['ROLE_FORMA_PAGAMENTO_RECEBIMENTO_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Formas de Pagamentos',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Formas de Pagamentos',
            },
          ],
        },
      },
      {
        path: 'contributionRange',
        name: 'contributionRange',
        component: () => import('@/views/settings/financial/ContributionRangeSetting.vue'),
        meta: {
          action: ['ROLE_FAIXA_CONTRIBUICAO_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Faixa de Contribuição',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Faixa de Contribuição',
            },
          ],
        },
      },
      {
        path: 'parameter',
        name: 'parameter',
        component: () => import('@/views/settings/financial/ParameterSetting.vue'),
        meta: {
          action: ['ROLE_PARAMETROS_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Parametros',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Parametros',
            },
          ],
        },
      },
      {
        path: 'taxaSettings',
        name: 'taxaSettings',
        component: () => import('@/views/settings/financial/TaxaSetting.vue'),
        meta: {
          action: ['ROLE_TAXA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Taxas',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Taxas',
            },
          ],
        },
      },
      {
        path: 'encargoSettings',
        name: 'encargoSettings',
        component: () => import('@/views/settings/financial/EncargoSetting.vue'),
        meta: {
          action: ['ROLE_ENCARGOS_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Encargos',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Encargos',
            },
          ],
        },
      },
      {
        path: 'tipoFaixaSettings',
        name: 'tipoFaixaSettings',
        component: () => import('@/views/settings/financial/TipoFaixaSetting.vue'),
        meta: {
          action: ['ROLE_TIPO_FAIXA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Tipos de Faixa',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Tipos de Faixa',
            },
          ],
        },
      },
      {
        path: 'periodoVigenciaSettings',
        name: 'periodoVigenciaSettings',
        component: () => import('@/views/settings/financial/PeriodoVigenciaSetting.vue'),
        meta: {
          action: ['ROLE_PERIODO_VIGENCIA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Períodos de Vigência',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Períodos de Vigência',
            },
          ],
        },
      },
      {
        path: 'matricialValoresSettings',
        name: 'matricialValoresSettings',
        component: () => import('@/views/settings/financial/MatrizValoresSetting.vue'),
        meta: {
          action: ['ROLE_VALOR_FAIXA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Matriz de Valores',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Matriz de Valores',
            },
          ],
        },
      },
      {
        path: 'moedaSettings',
        name: 'moedaSettings',
        component: () => import('@/views/settings/financial/MoedaSetting.vue'),
        meta: {
          action: ['ROLE_MOEDA_CONSULTAR'],
          resource: 'ACL',
          pageTitle: 'Moedas',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Financeiro | Moedas',
            },
          ],
        },
      },
    ],
  },
]
